import Asset from '../asset';
import GenericModel from '../generic-model';
import { ConditionalDescription } from './conditional-description';
import { PoleColor } from './enums/pole-color';
import { SignFrame } from './enums/sign-frame';
import { SignMeasurements } from './enums/sign-measurements';
import { SignPersonalizedTextType } from './enums/sign-personalized-text-type';
import { SignPositionType } from './enums/sign-position-type';
import { SignPressType } from './enums/sign-press-type';
import { SignShapeType } from './enums/sign-shape-type';
import { SignType } from './enums/sign-type';
import { SignPhoneNumberAdjustment } from './phone/sign-phone-number-adjustment';
import { SignAsset } from './sign-asset';
import { SignDetailLocation } from './sign-detail-location';
import { SignMinimal } from './sign-minimal';
import { SignParticipatingCompany } from './sign-participating-company';
import { SignTitleAdjustment } from './title/sign-title-adjustment';
import { SignFrameColor } from './enums/sign-frame-color';
import { SignRecupMethod } from './enums/sign-recup-method';
import { PrintProductionDto } from '../print-production/print-production-dto';

export class SignDetail extends GenericModel {
  archived: boolean;

  pairedWithSelf: boolean;
  pairedSign: SignMinimal;
  pairedSignId: number;

  participatingCompanies: SignParticipatingCompany[];
  type: SignType | null;
  title: string;
  phoneNumber: string;
  signMeasurements: SignMeasurements | null;
  pressType: SignPressType | null;
  remarks: string;

  defaultLocation: SignDetailLocation;
  roofLocation: string;

  examples: SignAsset[];
  offlineExamples: Asset[];

  nbColors: number;
  colorOne: string;
  colorTwo: string;
  colorThree: string;
  colorFour: string;

  frame: SignFrame | null;
  frameColor: SignFrameColor | null;
  recupMethod: SignRecupMethod | null;
  poleColor: PoleColor | null;
  shape: SignShapeType | null;
  position: SignPositionType | null;
  specialShape: ConditionalDescription;
  reflectable: ConditionalDescription;

  textType: SignPersonalizedTextType | null;
  textColors: string;
  textFont: string;
  textPrice: string;
  textMeasurements: string;
  backgroundColor: string;

  graphicsFinished: boolean;
  signComplete: boolean;
  oldLayout: boolean;

  minimumStock: number;

  immoValue: boolean;
  immoInfo: string;

  graphicalValue: boolean;
  graphicalInfo: string;

  studioValue: boolean;
  studioInfo: string;

  installerValue: boolean;
  installerInfo: string;

  titleAdjustments: SignTitleAdjustment[];

  phoneNumberAdjustments: SignPhoneNumberAdjustment[];

  transferExistingStockToNewLocation: boolean;

  withoutStock: boolean;
  singleBoardPrice: string;

  totalStock?: number;

  // display variables
  orderedAmount?: number;
  inOfferStock?: number;
  inProductionStock?: number;

  stockOfferSent: boolean;

  material: string;
  descending: boolean;
  printProduction: PrintProductionDto;
  displayPrices: boolean;
}
